import React from 'react'

function UnitViewSkeleton() {
  return (
    <div className="relative flex h-screen w-full items-center justify-center overflow-hidden bg-secondaryColour">
      <div className="skeleton"></div>

      <div className="absolute bottom-16 right-8 flex gap-4">
        <div className="skeleton h-[100px] w-[120px]"></div>
        <div className="skeleton h-[100px] w-[120px]"></div>
        <div className="skeleton h-[100px] w-[120px]"></div>
        <div className="skeleton h-[100px] w-[120px]"></div>
      </div>
    </div>
  )
}

export default UnitViewSkeleton
